import React from 'react'
import styles from './LoadingSpinner.scss'

export default function LoadingSpinner() {
  return (
    <div className={styles['c-loading-spinner']} data-testid="spinner-wrapper">
      <div className={styles['c-loading-spinner__spinner']} data-testid="spinner" />
    </div>
  )
}
